const CONNECTION_RECONNECTING = new Set(["reconnecting", "signalReconnecting"]);

export const REMOVED_FROM_INTERVIEW_MESSAGE =
  "You have been removed from this interview room.";

export function normalizeLiveInterviewConnectionState(connectionState) {
  if (connectionState && typeof connectionState === "object") {
    return String(connectionState.valueOf?.() || connectionState).trim();
  }
  return String(connectionState || "").trim();
}

export function getReconnectBannerMessage({
  connectionState,
  browserOnline = true,
  hasConnectedOnce = false,
} = {}) {
  if (browserOnline === false) {
    return "You're offline — trying to reconnect";
  }
  const state = normalizeLiveInterviewConnectionState(connectionState);
  const reconnecting =
    CONNECTION_RECONNECTING.has(state) ||
    Boolean(hasConnectedOnce && state === "connecting");
  return reconnecting ? "Reconnecting…" : "";
}

export function canRejoinDisconnectedSession(liveSessionState, meetingUiTerminated) {
  return String(liveSessionState || "").trim() === "disconnected" && !meetingUiTerminated;
}

export function canShowStaffRejoinLobby({
  role,
  liveSessionState,
  meetingUiTerminated,
  hasJoinedMeetingOnce,
} = {}) {
  if (String(role || "").trim().toLowerCase() === "candidate") {
    return false;
  }
  return (
    !meetingUiTerminated &&
    String(liveSessionState || "").trim() === "lobby" &&
    Boolean(hasJoinedMeetingOnce)
  );
}

export function getLobbyRejoinCopy({ canRejoin = false, role = "" } = {}) {
  if (!canRejoin) {
    return null;
  }
  const isCandidate = String(role || "").trim().toLowerCase() === "candidate";
  return {
    title: "Rejoin the interview",
    subtitle: isCandidate
      ? "Your selected camera, microphone, and speakers are kept. Rejoin when you are ready."
      : "The meeting is still in progress. Check your devices, then rejoin with the same role.",
    ctaLabel: "Rejoin Meeting",
    notice: "You disconnected from the meeting. Click Rejoin Meeting when you are ready.",
  };
}
